module.exports = __webpack_public_path__ + "static/media/Alfred M. Landon - 1936.f2b99e46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Alfred M. Landon - 1936.jpg
// module id = 433
// module chunks = 0